export enum ProgressSize {
  Small = 'small',
  Default = 'default'
}
